/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmStepFailureDetail {
    getFixupPrototypeFunction() { return AwsSsmStepFailureDetail.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmStepFailureDetail>): AwsSsmStepFailureDetail {
        let obj = Object.assign(new AwsSsmStepFailureDetail(), model);
        AwsSsmStepFailureDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmStepFailureDetail>): AwsSsmStepFailureDetail {
        if (!model) return null;
        return AwsSsmStepFailureDetail.newInstance(<AwsSsmStepFailureDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmStepFailureDetail) {
        if (!obj) return;

        models.AwsSsmStepFailureDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmStepFailureDetail): boolean {
        Object.setPrototypeOf(obj, AwsSsmStepFailureDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Stage of the execution when the failure occurred
     */
    stage: string;

    /**
     * type of the failure
     */
    type: string;

    details: { [key: string]: string; };

}
